module.exports = __webpack_public_path__ + "static/media/eng-grey.34289050.svg";